import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

import '../styles/index.scss'

import Layout from '../components/layout'
import Partners from '../components/partners'
// import Speakers from '../components/speakers'
// import Agenda from '../components/agenda'
import TextSection from '../components/textSection'
import Header from '../components/header'

const IndexPage = () => (
  <StaticQuery
    query={graphql`
      query SectionsQuery {
        allMarkdownRemark(sort: { fields: frontmatter___order }) {
          edges {
            node {
              id
              html
              frontmatter {
                title
                html_id
              }
            }
          }
        }
      }
    `}
  >
    {data => (
      <Layout>
        <Header />
        {data.allMarkdownRemark.edges.map(({ node }) => (
          <TextSection
            id={node.frontmatter.html_id}
            title={node.frontmatter.title}
            description={node.html}
            key={node.id}
          />
        ))}

        <Partners />
        {/* <Speakers /> */}
        {/* <Agenda /> */}
      </Layout>
    )}
  </StaticQuery>
)

export default IndexPage
